import { Link } from "react-router-dom";

export default function LegalFooter({ variant = "light" }) {
  const linkClass =
    variant === "dark"
      ? "text-white/50 hover:text-white"
      : "text-zinc-500 hover:text-black";
  return (
    <div className={`text-[11px] leading-relaxed ${variant === "dark" ? "text-white/40" : "text-zinc-400"}`}>
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1">
        <Link to="/termos" data-testid="footer-terms" className={`${linkClass} underline underline-offset-2`}>
          Termos
        </Link>
        <span>·</span>
        <Link to="/regras" data-testid="footer-guidelines" className={`${linkClass} underline underline-offset-2`}>
          Regras da comunidade
        </Link>
      </div>
      <div className="text-center mt-1">
        © CD NOIR LTD · <a href="mailto:support@angolauk.co.uk" className={linkClass}>support@angolauk.co.uk</a>
      </div>
    </div>
  );
}
